import Vue from 'vue';

export enum EventBusEvents {
  ChangeThemeEvent = 'change_theme_event'
}

export const eventBus = new Vue();
